export interface INavData {
  id?: number;
  name?: string;
  url?: string | any[];
  href?: string;
  icon?: string;
  title?: boolean;
  children?: INavData[];
  divider?: boolean;
  isShow?: boolean;
}

export const navItems: INavData[] = [
  {
    title: true,
    name: "POOL PARTICIPATION",
    isShow: true,
  },
  {
    id: 100,
    name: "Dashboard",
    url: "/dashboard",
    icon: "fa fa-home",
    isShow: true,
  },
  {
    id: 1,
    name: "Earnings",
    url: "/earnings",
    icon: "fa fa-bar-chart",
    isShow: true,
    children: [
      {
        id: 8,
        name: "Pool Earnings",
        url: "/earnings/pool-earnings",
        icon: "icon-none",
        isShow: true,
      },
      {
        id: 9,
        name: "Voyage PnLs",
        url: "/earnings/voyage-earnings",
        icon: "icon-none",
        isShow: true,
      },
    ],
  },
  {
    id: 2,
    name: "Market Updates",
    url: "/market",
    icon: "fa fa-chart",
    isShow: true,
  },
  {
    id: 102,
    name: "Monthly Ops Circulars",
    url: "/monthly-operation-circulars",
    icon: "fa fa-i-file",
    isShow: true,
  },
  {
    id: 5,
    name: "Reports",
    url: "/report",
    icon: "fa fa-align-left",
    isShow: true,
  },
  {
    id: 4,
    name: "Documents",
    url: "/document",
    icon: "fa fa-folder",
    isShow: true,
  },
  {
    id: 3,
    name: "Research",
    url: "/research",
    icon: "fa fa-search",
    isShow: true,
  },
  {
    id: 103,
    name: "Vessel Tracking",
    url: "/vessel-tracking",
    icon: "fa fa-vessel-tracking",
    isShow: true,
  },
  {
    id: 101,
    name: "Workshops",
    url: "/workshops",
    icon: "fa fa-workshops",
    isShow: true,
  },
  {
    title: true,
    name: "OTHERS",
    isShow: true,
  },
  {
    name: "Help & Support",
    url: "/help-support",
    icon: "fa fa-life-ring",
    isShow: true,
  },
  {
    name: "Settings",
    url: "/setting",
    icon: "fa fa-cog",
    isShow: true,
  },
];
